<template>
  <div class="btn" :class="{'d-flex justify-center':isCenter, 'w-full': isBlock}" :style="{width: width? width:''}">
    <v-btn
      class="btn-text"
      :class="{ 'white--text': !isOutlined && !isGradient, 'is-gradient': isGradient }"
      :color="color"
      :width="width"
      :height="height"
      :block="isBlock"
      :disabled="isDisabled"
      :dark="isDark"
      depressed
      @click.stop="clickBtn()"
      :outlined="isOutlined"
    >
      {{ $t(buttonText) }}
    </v-btn>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    buttonText: String,
    width: [Number, String],
    height: Number,
    isBlock: {
      type: Boolean,
      default: false,
    },
    isOutlined: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary'
    },
    isCenter:{
      type: Boolean,
      default: false
    },
    isDark:{
      type: Boolean,
      default: false
    },
    isGradient:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickBtn() {
      this.$emit("clickBtn");
    },
  },
};
</script>
<style lang="scss">
button.is-gradient{
  background: linear-gradient(to right, #FFFFFF, #95B8E1);
  color: #6285A7 !important;
}
</style>